/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".multi-dropdown[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap}.multi-dropdown[_ngcontent-%COMP%]   .multi-dropdown-input[_ngcontent-%COMP%]{display:none}.multi-dropdown[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]{margin-right:2px}.multi-dropdown[_ngcontent-%COMP%]   .badge[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border:none;background:0 0;color:inherit;padding:0 1px;font-size:larger}"];
export { styles as styles };
